import { Button, clx } from '@medusajs/ui';

/**
 * Loading skeleton for order payment notification button
 */
const ButtonSkeleton = () => (
  <div className="bg-grey-20 h-10 w-32 animate-pulse rounded-sm" />
);

interface OrderPaymentNotificationButtonProps {
  hasPendingRequest: boolean;
  isLoading: boolean;
  onClick: () => void;
}

/**
 * Pure presentational component for order payment notification button
 * Displays different states based on whether there's a pending payment notification request
 */
export const OrderPaymentNotificationButton = ({
  hasPendingRequest,
  isLoading,
  onClick,
}: OrderPaymentNotificationButtonProps) => {
  if (isLoading) {
    return <ButtonSkeleton />;
  }

  const baseStyles = 'rounded-sm px-4 py-2';
  const variantStyles = hasPendingRequest
    ? 'border border-solid border-black-10 text-black-10'
    : 'bg-primary-50 text-white-10 shadow-none';

  return (
    <Button
      variant={hasPendingRequest ? 'secondary' : 'primary'}
      onClick={onClick}
      className={clx(baseStyles, variantStyles)}
      data-testid={
        hasPendingRequest
          ? 'order-payment-notification-button-pending'
          : 'order-payment-notification-button'
      }
    >
      {hasPendingRequest ? '待審核繳款通知' : '繳款通知'}
    </Button>
  );
};

export default OrderPaymentNotificationButton;
